import inputRenderPlugin from './input';
import inputNumberRenderPlugin from './inputNumber';
import textAreaRenderPlugin from './textArea';
import passwordRenderPlugin from './password';
import richEditorRenderPlugin from './richEditor';

export {
  inputRenderPlugin,
  inputNumberRenderPlugin,
  textAreaRenderPlugin,
  passwordRenderPlugin,
  richEditorRenderPlugin,
}

export default [inputRenderPlugin, inputNumberRenderPlugin, textAreaRenderPlugin, passwordRenderPlugin, richEditorRenderPlugin];